<template>
  <li :class="classNames">
    <slot name="default">
      <template v-if="refinement?.attribute === 'has_tow_hook'">
        {{ $t('layout.filters.towhook') }}
      </template>
      <template v-else-if="refinement?.attribute === 'min_subscription_price'">
        {{ $t('layout.filters.subscription.price_range_label') }}
        {{ refinement?.operator }}
        {{ formatPrice(isSubscriptionPage ? normalizePriceToApp(refinement?.value) : refinement?.value) }}
      </template>
      <template v-else-if="refinement?.attribute === 'min_day_price'">
        {{ $t('layout.filters.subscription.price_range_label') }}
        {{ refinement?.operator }}
        {{ formatPrice(isSubscriptionPage ? normalizePriceToApp(refinement?.value) : refinement?.value) }}
      </template>
      <template v-else-if="refinement?.attribute === 'seats'">
        {{ $t('layout.filters.seats') }} {{ refinement?.label }}
      </template>
      <template v-else>
        {{ refinement?.label }}
      </template>
    </slot>

    <slot name="clear">
      <span @click.prevent="clear">
        <i class="fa fa-solid fa-xmark pl-3"></i>
      </span>
    </slot>
  </li>
</template>

<script>
export default {
  props: {
    refinement: {
      type: Object,
      required: true
    },
    classNames: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isSubscriptionPage: window.isSubscriptionPage
    }
  },
  methods: {
    clear() {
      this.$emit('clear', this.refinement);
    }
  },
}
</script>

<style scoped>

</style>
